import equal from 'deep-equal';
import Radio from '@material-ui/core/Radio';
import { ErrorMessage } from '../helpers';
import ListBase, { ListProps } from './ListBase';
import { useContextField } from '../../../api';

export interface RadioListProps<T> extends ListProps<T> {
    name: string;
    onChange?(selected: T): void;
    value?: T;
    checked?(a?: T, b?: T): boolean;
}

export default <T extends any>(props: RadioListProps<T>) => {
    const { name, onChange, options, checked, ...baseProps } = props;
    const [field, _, helper] = useContextField<T>(props.name);
    return <>
        <ListBase
            {...baseProps}
            options={options.map(({ value, ...option }) => {
                const selected = props.value === undefined ? field.value : props.value;
                return {
                    ...option,
                    control: <Radio color="primary" checked={checked ? checked(selected, value) : equal(selected, value)} onChange={_ => { helper.setValue(value); onChange && onChange(value); }} />
                };
            })} />
        <ErrorMessage name={name} />
    </>
}
